import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';


export function ConfirmPage() {

    return (
        <Box>
            <Grid container justifyContent={'flex-start'}>
                <Grid size={6}>
                    <Typography variant="h6">
                        You have succssfully authenticated Knoll.<br/>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );

}